<div class="modal" *ngIf="memberToDetach && group">
    <div class="header">
        <h1 class="title" translate [translateParams]="{ email: memberToDetach.username, group: group.name }">
            PREMIUM_ADMIN_MEMBER_MODAL_DETACH_MEMBER_FROM_GROUP_QUESTION</h1>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <ng-container *ngIf="(detachMemberFromGroupPending$ | async); else notProcessing">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notProcessing>
            <div class="section">
                <div class="description" translate>PREMIUM_ADMIN_MEMBER_MODAL_DETACH_MEMBER_FROM_GROUP_QUESTION_CONFIRMATION</div>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()" [disabled]="(detachMemberFromGroupPending$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="detachMemberFromGroup()" [disabled]="(detachMemberFromGroupPending$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_DETACH_MEMBER_FROM_GROUP_BUTTON_LABEL_DETACH_MEMBER</button>
    </div>
</div>